import { render, staticRenderFns } from "./ProgramFaqsTable.vue?vue&type=template&id=75120414&"
import script from "./ProgramFaqsTable.vue?vue&type=script&lang=js&"
export * from "./ProgramFaqsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports